import { Minus } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RemoveIcon = createLucideIcon(Minus);
